import React from 'react';
import styled from 'styled-components';
import SliderModal from './SliderModal';
import RentingChoiceButton from './RentingChoiceButton';

/* global tw */

const ClockIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </svg>
);

const RouteIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="6" cy="19" r="2.2" />
        <circle cx="18" cy="5" r="2.2" />
        <path d="M8 18.5h6a4 4 0 0 0 0-8H9a4 4 0 0 1 0-8h5" />
    </svg>
);

const PlaneIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-4.5z" />
    </svg>
);

const RentingChoicesWrapper = styled.div`
  ${tw`mx-auto lg:-mx-2 px-6 lg:px-6 pt-2 relative z-0 max-h-full w-full overflow-y-scroll overflow-x-hidden scrolling-touch`};
  -webkit-overflow-scrolling: touch;
`

const ChoiceHeading = styled.h3`
    ${tw`w-full sticky`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 1.375rem;
    font-weight: 700;
    color: #F5F5F7;
    letter-spacing: -0.02em;
    margin-bottom: 0.75rem;
    margin-top: 0.75rem;
    span {
        display: block;
        font-size: 1.5rem;
        background: linear-gradient(135deg, #D8B4FE 0%, #B15CFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: -0.03em;
    }
`

const RentingChoicesModal = (props) => (
    <SliderModal active={props.active}>
        <RentingChoicesWrapper>
            <ChoiceHeading>What's your <span>Choice of Rental?</span></ChoiceHeading>
            <RentingChoiceButton
                onClick={() => props.onClick(6, true)}
                icon={<ClockIcon />}
                title='Hourly'
                description='A chauffeur-driven car that stays with you to roam around the city.'
            />
            <RentingChoiceButton
                onClick={() => props.onClick(1, true)}
                icon={<RouteIcon />}
                title='Outstation'
                description='Travel between cities, driven by a professional chauffeur.'
            />
            <RentingChoiceButton
                onClick={() => props.onClick(3, true)}
                icon={<PlaneIcon />}
                title='Airport'
                description='Premium pickups and drops to or from the airport.'
            />
        </RentingChoicesWrapper>
        {props.hasFilter &&
            <p>Show Filters Here</p>
        }
    </SliderModal>
);

export default RentingChoicesModal;
